<template>
  <div class="finance-code">
    <div class="row">
      <div class="col-sm-12">
        <p class="h4"><strong>Code:</strong> {{ financeCode.code }}</p>
        <p class="h4"><strong>Description:</strong> {{ financeCode.description }}</p>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-default"
            :to="{ path: `/contracts/finance-codes/edit/${financeCode.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinanceCode',
  props: {
    object: {
      type: Object
    }
  },
  data () {
    return {
      financeCode: {
        Organization: {
        },
        code: '',
        description: ''
      }
    }
  },
  mounted () {
    this.financeCode = this.object
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/FinanceCode.vue